var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"banner"},[_c('div',{staticClass:"toolbar-content"},[_vm._m(0),_c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{staticClass:"logout-btn",attrs:{"text":""},on:{"click":_vm.logout}},[_vm._v("Log Out")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('img',{staticStyle:{"width":"125px"},attrs:{"src":require("../assets/logo_new.svg")}})])
}]

export { render, staticRenderFns }